import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  hide: {
    visibility: 'hidden',
  },
}));
